// import HotCase from "../assets/img/kitchen-equipments/hot-case.jpg";
// import TiltingGrinder from "../assets/img/kitchen-equipments/Tilting-Grinder.jpg";
// import DeepFatFryer from "../assets/img/kitchen-equipments/deep-fat-fryer.jpg";
// import FootPressSingleBowlSinck from "../assets/img/kitchen-equipments/foot-press-Single-Bowl-Sinck.jpg";
// import VegetableCutter from "../assets/img/kitchen-equipments/vegetable-cutter.jpg";
// import DoughKneader from "../assets/img/kitchen-equipments/dough-kneader.jpg";
// import SteamUnitCookingBoilerVessels from "../assets/img/kitchen-equipments/steam-unit-cooking-boiler-vessels.jpg";
// import SteamVesselsUnit from "../assets/img/kitchen-equipments/bakery-showcase.jpg";
// import TripleBowlSink from "../assets/img/kitchen-equipments/triple-bowl-sink.jpg";
// import footsanitizerperusingmsstand from "../assets/img/kitchen-equipments/foot-sanitizer-perusing-ms-stand.jpg";
// import trayracktrolley from "../assets/img/kitchen-equipments/tray-rack-trolley.jpg";
// import servicetrolley from "../assets/img/kitchen-equipments/service-trolley.jpg";
// import storagetrolley from "../assets/img/kitchen-equipments/storage-trolley.jpg";
// import platformtrolley from "../assets/img/kitchen-equipments/platform-trolley.jpg";
// import ChickenGrillMachine from "../assets/img/kitchen-equipments/Chicken-Grill-Machine.jpg";
// import rebournblender from "../assets/img/kitchen-equipments/rebourn-blender.jpg";
// import spicemixingmachine from "../assets/img/kitchen-equipments/spice-mixing-machine.jpg";
// import incensepowdermixingmachine from "../assets/img/kitchen-equipments/incense-powder-mixing-machine.jpg";
// import detergentmixingmachine from "../assets/img/kitchen-equipments/detergent-mixing-machine.jpg";
// import RibbonBlenderAgarbathi from "../assets/img/kitchen-equipments/Ribbon-Blender-Agarbathi.jpg";
// import RibbonBlenderMixer from "../assets/img/kitchen-equipments/Ribbon-Blender-Mixer.jpg";
// import SSDiningTable from "../assets/img/kitchen-equipments/ss-dining-table.jpg";
// import attakneader from "../assets/img/kitchen-equipments/atta-kneader.jpg";
// import StainlessSteelTrolley from "../assets/img/kitchen-equipments/Stainless-Steel-Trolley.jpg";
// import IndustrialTrolley from "../assets/img/kitchen-equipments/Industrial-Trolley.jpg";
// import platecollectiontrolley from "../assets/img/kitchen-equipments/plate-collection-trolley.jpg";
// import MasalaTrolley from "../assets/img/kitchen-equipments/Masala-Trolley.jpg";
// import singleburnerrange from "../assets/img/kitchen-equipments/single-burner-range.jpg";
// import DosaPlate1 from "../assets/img/kitchen-equipments/Dosa-Plate-1.jpg";
// import RiceVesselsWithBurner from "../assets/img/kitchen-equipments/Rice-Vessels-With-Burner.jpg";
// import CommercialBainMarie from "../assets/img/kitchen-equipments/Commercial-Bain-Marie.jpg";
// import StainlessSteelChair from "../assets/img/kitchen-equipments/Stainless-Steel-Chair.jpg";
// import OnionBin from "../assets/img/kitchen-equipments/Onion-Bin.jpg";
// import PlateWashSink from "../assets/img/kitchen-equipments/Plate-Wash-Sink.jpg";
// import WorkingTablewithSink from "../assets/img/kitchen-equipments/Working-Table-with-Sink.jpg";
// import IndustrialRibbonBlenderMachine from "../assets/img/kitchen-equipments/Industrial-Ribbon-Blender-Machine.jpg";

const KITCHEN_EQUIPMENTS_DATA: any[] = [];

// const KITCHEN_EQUIPMENTS_DATA = [
//   {
//     title: "Restaurant Kitchen Equipment",
//     equipmentItem: [
//       {
//         imgSrc: VegetableCutter,
//         imgAlt: "Vegetable Cutter",
//         imgCaption: "Vegetable Cutter",
//       },
//       {
//         imgSrc: DoughKneader,
//         imgAlt: "Dough Kneader",
//         imgCaption: "Dough Kneader",
//       },
//       {
//         imgSrc: attakneader,
//         imgAlt: "Atta Kneader",
//         imgCaption: "Atta Kneader",
//       },
//       {
//         imgSrc: TiltingGrinder,
//         imgAlt: "Tilting Grinder",
//         imgCaption: "Tilting Grinder",
//       },
//       {
//         imgSrc: DosaPlate1,
//         imgAlt: "Dosa/Tawa Plate",
//         imgCaption: "Dosa/Tawa Plate",
//       },
//       {
//         imgSrc: DeepFatFryer,
//         imgAlt: "Deep Fat Fryer",
//         imgCaption: "Deep Fat Fryer",
//       },
//       {
//         imgSrc: ChickenGrillMachine,
//         imgAlt: "Grill Chicken Maker",
//         imgCaption: "Grill Chicken Maker",
//       },
//     ],
//   },
//   {
//     title: "Steam Line Equipment",
//     equipmentItem: [
//       {
//         imgSrc: HotCase,
//         imgAlt: "Hot Case",
//         imgCaption: "Hot Case",
//       },
//       {
//         imgSrc: SteamVesselsUnit,
//         imgAlt: "Steam Cooking Vessels Unit",
//         imgCaption: "Steam Cooking Vessels Unit",
//       },
//       {
//         imgSrc: RiceVesselsWithBurner,
//         imgAlt: "Rice Vessels With Burner",
//         imgCaption: "Rice Vessels With Burner",
//       },
//       {
//         imgSrc: SteamUnitCookingBoilerVessels,
//         imgAlt: "Steam Cooking Boiler Unit",
//         imgCaption: "Steam Cooking Boiler Unit",
//       },
//       {
//         imgSrc: singleburnerrange,
//         imgAlt: "Single Burner Range",
//         imgCaption: "Single Burner Range",
//       },
//     ],
//   },
//   {
//     title: "Trolleys",
//     equipmentItem: [
//       {
//         imgSrc: trayracktrolley,
//         imgAlt: "Tray Rack Trolley",
//         imgCaption: "Tray Rack Trolley",
//       },
//       {
//         imgSrc: servicetrolley,
//         imgAlt: "Service Trolley",
//         imgCaption: "Service Trolley",
//       },
//       {
//         imgSrc: storagetrolley,
//         imgAlt: "Storage Trolley",
//         imgCaption: "Storage Trolley",
//       },
//       {
//         imgSrc: platformtrolley,
//         imgAlt: "Platform Trolley",
//         imgCaption: "Platform Trolley",
//       },
//       {
//         imgSrc: StainlessSteelTrolley,
//         imgAlt: "Commercial Trolley",
//         imgCaption: "Commercial Trolley",
//       },
//       {
//         imgSrc: IndustrialTrolley,
//         imgAlt: "Industrial Trolley",
//         imgCaption: "Industrial Trolley",
//       },
//       {
//         imgSrc: platecollectiontrolley,
//         imgAlt: "Plate Collection Trolley",
//         imgCaption: "Plate Collection Trolley",
//       },
//       {
//         imgSrc: MasalaTrolley,
//         imgAlt: "Masala Trolley",
//         imgCaption: "Masala Trolley",
//       },
//     ],
//   },
//   {
//     title: "Stainless Steel Work Units",
//     equipmentItem: [
//       {
//         imgSrc: WorkingTablewithSink,
//         imgAlt: "Work Table with Sink",
//         imgCaption: "Work Table with Sink",
//       },
//       {
//         imgSrc: CommercialBainMarie,
//         imgAlt: "Commercial Bain Marie",
//         imgCaption: "Commercial Bain Marie",
//       },
//       {
//         imgSrc: StainlessSteelChair,
//         imgAlt: "Stainless Steel Chair",
//         imgCaption: "Stainless Steel Chair",
//       },
//       {
//         imgSrc: SSDiningTable,
//         imgAlt: "Dining Table",
//         imgCaption: "Dining Table",
//       },
//       {
//         imgSrc: footsanitizerperusingmsstand,
//         imgAlt: "Foot Sanitizer Perusing MS Stand",
//         imgCaption: "Foot Sanitizer Perusing MS Stand",
//       },
//       {
//         imgSrc: OnionBin,
//         imgAlt: "Vegetable Bin",
//         imgCaption: "Vegetable Bin",
//       },
//     ],
//   },
//   {
//     title: "Stainless Steel Sinks",
//     equipmentItem: [
//       {
//         imgSrc: PlateWashSink,
//         imgAlt: "Plate Wash Sink",
//         imgCaption: "Plate Wash Sink",
//       },
//       {
//         imgSrc: TripleBowlSink,
//         imgAlt: "Triple Bowl Sink",
//         imgCaption: "Triple Bowl Sink",
//       },
//       {
//         imgSrc: FootPressSingleBowlSinck,
//         imgAlt: "Foot press Single Bowl Sink",
//         imgCaption: "Foot press Single Bowl Sink",
//       },
//     ],
//   },
//   {
//     title: "Stainless Steel Mixers",
//     equipmentItem: [
//       {
//         imgSrc: rebournblender,
//         imgAlt: "Ribbon Blender Mixer",
//         imgCaption: "Ribbon Blender Mixer",
//       },
//       {
//         imgSrc: spicemixingmachine,
//         imgAlt: "Masala/Spice Mixing Machine",
//         imgCaption: "Masala/Spice Mixing Machine",
//       },
//       {
//         imgSrc: RibbonBlenderMixer,
//         imgAlt: "Ribbon Blender Mixer",
//         imgCaption: "Ribbon Blender Mixer",
//       },
//       {
//         imgSrc: incensepowdermixingmachine,
//         imgAlt: "Incense Powder Mixing Machine",
//         imgCaption: "Incense Powder Mixing Machine",
//       },
//       {
//         imgSrc: detergentmixingmachine,
//         imgAlt: "Dry Detergent Mixing Machine",
//         imgCaption: "Dry Detergent Mixing Machine",
//       },
//       {
//         imgSrc: RibbonBlenderAgarbathi,
//         imgAlt: "Ribbon Blender Agarbathi",
//         imgCaption: "Ribbon Blender Agarbathi",
//       },
//       {
//         imgSrc: IndustrialRibbonBlenderMachine,
//         imgAlt: "Industrial Ribbon Blender Machine",
//         imgCaption: "Industrial Ribbon Blender Machine",
//       },
//     ],
//   },
// ];

export { KITCHEN_EQUIPMENTS_DATA };
